module.exports = __webpack_public_path__ + "static/img/Car.1d3c577a.png";